import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { applicationsApi } from 'api/applications';

export const useApplications = (): UseQueryResult<any> =>
  useQuery(['applications'], () => applicationsApi.getAll() || null);
